<div class="fp-customer-details-container">
  <div class="fp-logo" aria-hidden="true" role="img">
    <img alt="freshpass logo" aria-hidden="true" class="logo"
      [src]="programDisplayData?.imageAssets?.customerDetailsPrimaryLogo" />
  </div>
  <div class="fp-customer-details-main">
    <div aria-level="1" class="fp-customer-details-title" role="heading">
     {{freshpassTitle}}
    </div>
    <div *ngIf="displaySubTypeLink" class="fp-customer-details-sub-type">
      <span class="fp-customer-details-link" *ngIf="userCustomerDetails?.isPrimaryFreshPassUser === false; else showLink">
        {{userCustomerDetails.subscriptionType}}
      </span>
      <ng-template #showLink>
        <a [routerLink]="subTypeLink" class="fp-customer-details-link">
          {{userCustomerDetails.subscriptionType}}
          <span aria-hidden="true" class="img-subs" role="img">
            <img alt="right arrow icon" aria-hidden="true" class="fp-customer-details-right-arrow"
              src="ocsp-web-ui/dist/assets/images/Chevron-right.svg" />
          </span>
        </a>
      </ng-template>
    </div>
    <div class="fp-customer-details-copy">
      {{ freshpassBenefitsDescription }}
    </div>
  </div>
  <div class="fp-savings-details-container">
    <div class="fp-lifetime-savings-container" aria-label="${{userCustomerDetails.lifeSavings}} {{LIFETIMESAVINGS_TEXT}}">
      <div class="fp-lifetime-saved" aria-hidden="true">${{userCustomerDetails.lifeSavings}}</div>
      <div class="fp-lifetime-saved-description" aria-hidden="true">
        {{LIFETIMESAVINGS_TEXT}}
          <span class="tooltip-container">
            <button aria-expanded="false" aria-label="View personalized savings info"
                    class="noBgBrdr freshPassTooltip" 
                    [attr.data-original-title]="getTooltipContent()"
                    data-placement="top"
                    data-qa="freshPassTooltip" data-toggle="tooltip">
                <img alt="info icon image" class="info-icon" aria-hidden="true"
                     role="presentation" src="ocsp-web-ui/dist/assets/images/info_icon_2.png"/>
            </button>
          </span>
      </div>
    </div>
    <div class="fp-time-saved-container" aria-label="{{userCustomerDetails.timeSavings}} {{HOURSSAVED_TEXT}}">
      <div class="fp-lifetime-saved" aria-hidden="true">{{userCustomerDetails.timeSavings}}</div>
      <div class="fp-lifetime-saved-description" aria-hidden="true">{{HOURSSAVED_TEXT}}</div>
    </div>
  </div>
</div>

<hr class="customer-details-hr" />
